import { DataManager } from 'utils/DataManager/dataManager';
import { IPrintServiceDataManager } from 'typings/dataManagers';
import { DataState } from 'typings/enums';

class PrintServiceDataManager extends DataManager implements IPrintServiceDataManager {

    async requestPdfs(
        masterAccountId: string,
        cycleId: Nullable<number>,
        managerIds: string[]): Promise<IPrintStatusOutput> {
        const managerIdParameter = `?managerSourceId=${managerIds.join('&managerSourceId=')}`;
        const receive = () => this._postDataRequest<string[], IPrintStatusOutput>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employee/compMemo/printPdf${managerIdParameter}`, managerIds);
        const status = await this.getData<IPrintStatusOutput>(receive, false);
        return status ?? {} as IPrintStatusOutput;
    }

    async pollPdfProgress(masterAccountId: string, cycleId: Nullable<number>, pdfRequestId: string): Promise<IPrintPollStatus> {
        const receive = () => this._postDataRequest<null, IPrintPollStatus>(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employee/compMemo/poll?requestId=${pdfRequestId}`, null);
        return await this.getData<IPrintPollStatus>(receive, false) ?? {} as IPrintPollStatus;
    }

    async downloadPdfs(masterAccountId: string, cycleId: Nullable<number>, pdfUrls: string[]): Promise<void> {
        const receive = () => this._downloadDataRequest(
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employee/compMemo/downloadPdf`, 'CompMemo.zip', 'POST', pdfUrls);
        await this.getData<void>(receive, false);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { PrintServiceDataManager };
export default PrintServiceDataManager;